import { css } from '@linaria/core';
import { Box, HStack } from '@cbhq/cds-web/layout';
import { TextHeadline } from '@cbhq/cds-web/typography';

const chipStyles = css`
  border-width: 3px;
  border-color: var(--background);
`;

type PointsChipProps = {
  points: number;
};

export function PointsChip({ points }: PointsChipProps): React.ReactElement {
  return (
    <Box>
      <HStack
        alignItems="center"
        background="transparent"
        borderRadius="roundedXLarge"
        spacingHorizontal={1}
        spacingVertical={0}
        className={chipStyles}
      >
        <TextHeadline as="span" dangerouslySetColor="var(--background)">
          +{points}
        </TextHeadline>
      </HStack>
    </Box>
  );
}
